import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCombosCreateDescriptionControllerModule } from './controllers/ProgramsCombosCreateDescriptionController';

export const ProgramsCombosCreateDescriptionView = angular
  .module('acme.view.application.programs.combos.create.description', [
    uiRouter,
    'ui.bootstrap',
    ProgramsCombosCreateDescriptionControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.combos.create.description',
      url: '',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateDescriptionController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/description/description.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Combo Description',
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.programs.combos.edit.description',
      url: '',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateDescriptionController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/description/description.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Combo Description',
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
      },
    });
  }).name;
